import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FallbackScreen from './FallbackScreen';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('Error!', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <FallbackScreen />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundary;
